import { NOVEL_COLLECTION } from 'redux/constant/novelCollection'
import { createListSelector } from 'redux/utils'

export const selectNovelCollectionData = createListSelector(NOVEL_COLLECTION)
